<app-heatmap-chart
  [series]="series"
  [loading]="isLoading"
  [xLabels]="xLabels"
  [yLabels]="yLabels"
></app-heatmap-chart>
